Auth = require 'db/auth'
Controller = require 'controller'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
TrelloModel = require 'models/internal/trello-model'
Util = require 'lib/util'
_ = require 'underscore'
xtend = require 'xtend'

module.exports = class Notification extends TrelloModel
  @PAGE_SIZE: 10
  typeName: 'Notification'
  urlRoot: '/1/notifications'
  @loadAllPromise: null

  @sortedByDateDescending: (modelCache) ->
    _.sortBy modelCache.all('Notification'), (notification) ->
      -(new Date(notification.get('date'))).getTime()

  @unreadCount: (cache) ->
    cache.all('Notification')
    .filter (notification) -> notification.get('unread')
    .length

  @loadAllNotifications: (idOrUsername) ->
    return @loadAllPromise if @loadAllPromise?
    @loadAllPromise = ModelLoader.loadAllNotificationData(idOrUsername)

  getModel: -> @collection.options.model

  getBoard: ->
    if (idBoard = @get('data')?.board?.id)?
      @modelCache.get 'Board', idBoard
    else
      null

  getMember: ->
    @modelCache.get('Member', @get('idMemberCreator'))?.toJSON()

  triggerCacheEvents: (modelCache, event) ->
    for idModel in @idModels()
      modelCache.trigger "#{ event }:#{ @typeName }:#{ idModel }"
    return

  idModels: -> (value.id for key, value of (@get('data') ? {}) when value?.id?)

  isCommentLike: ->
    @get('type') in ['commentCard', 'copyCommentCard']

  isAddAttachment: ->
    @get('type') == 'addAttachmentToCard'

  getExpandedData: ->
    data = xtend (@toJSON().data ? {}),
      date: @get('date')
      unread: @get('unread')

    data[@get('type')] = true

    { board, card, organization } = data

    data

  markRead: ->
    @update({ unread: false })

  toggleRead: ->
    @update({ unread: !@get('unread') })

  navigateToView: ->
    data = @get('data')
    if data? && data.card? && data.board?
      Controller.displayBoard({ idBoard: data.board.id, idCard: data.card.id }).done()
      true
    else if @get('type') == 'memberJoinedTrello'
      document.location = '/recommend'
      true
    else if @get('type') == 'createdEnterpriseJoinRequest' && Auth.me().isEnterpriseAdminOf(data.enterprise)
      Controller.enterpriseDashTab(data.enterprise.id, 'teams')
      true
    else
      false

  getUrlOfTarget: ->
    data = @get('data')
    if data.enterprise? && Auth.me().isEnterpriseAdminOf(data.enterprise)
      Controller.getEnterpriseAdminDashboardUrl(data.enterprise.id)
    else if data.card?
      Controller.getCardUrlWithoutModels(
        data.board.id
        data.card.id
        data.card.name
      )
    else if data.board?
      Controller.getBoardUrl(data.board)
    else if data.organization?
      # use org.id since name has funky capitalization issues
      Controller.getOrganizationUrl(data.organization.id)
    else
      Controller.getMemberNotificationsUrl()



// WEBPACK FOOTER //
// ./app/scripts/models/notification.coffee